import Project from '@/types/purchaseRequest/project'
import { BaseService } from './../../base'
export class ProjectService extends BaseService<Project>() {
    static get entity (): string {
        return 'project'
    }
    static get responseName (): string {
        return 'project'
    }
}